import React, { Component } from "react";
import {
  Row,
  Col,
  UncontrolledAlert,
  Card,
  Button,
  CardHeader,
  CardBody
} from "reactstrap";
import { MdAdd, MdSearch } from "react-icons/md";
import Formsy from "formsy-react";
import { Spinner } from "../../Shared";
import { TextInput /* MyCheckbox */ } from "../../Shared/Forms";
import { DatePicker } from "../../Shared/Forms/DateTimePicker";
import { dateTimeutils } from "../../../_utils";
import { Link } from "react-router-dom";
import { ViewEventsAttendees } from "../../../_constants/RouteVariables";
import Joyride, { ACTIONS, EVENTS, STATUS } from "react-joyride";
import { tourMessages } from "../../../_constants/tutorialmessages/ManualMessages";
class EventForm extends Component {
  constructor(props){
  super(props);
  this.state = {
    canSubmit: false,
    run: false,
    stepIndex: 0,
    steps: [
      {
        target: tourMessages.adminEventForm.target,
        content: (
          <div>
            <p>{tourMessages.adminEventForm.title}</p>
          </div>
        ),
        placement: "left",
        locale: { skip: "SKIP", close: "Next" },
      },
      tourMessages.default,
    ],
  };
  }
 

  disableButton = () => {
    this.setState({ canSubmit: false });
  };

  enableButton = () => {
    this.setState({ canSubmit: true });
  };

  handleSubmit = data => {
    delete data.isWholeDay;
    data = {
      ...data,
      startDate: dateTimeutils.isoDate(data.startDate),
      endDate: dateTimeutils.isoDate(data.endDate)
    };
    this.props.submitAction(data);
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.submitted) {
      this.resetForm();
    }
    if (nextProps.showNextJoyRide) {
      this.setState({ run: true });
      this.props.setNextJoyRide();
    }
  }

  resetForm = () => {
    this.refs.eventForm.reset();
    if (this.createdEndDate && this.createdStartDate) {
      this.createdEndDate.changeValue(null);
      this.createdStartDate.changeValue(null);
    }
  };

  reset = () => {
    this.props.reset();
    this.resetForm();
  };
  handleJoyrideCallback = data => {
    const { action, index, status, type } = data;

    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      this.setState({ stepIndex: index + (action === ACTIONS.PREV ? -1 : 1) });
    } else if ([STATUS.CANCEL, STATUS.CANCEL].includes(status)) {
    } else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      if ([STATUS.SKIPPED].includes(status)) {
        this.setState({ run: false });
      } else {
        this.props.startJoyRideAtDataTable();
      }
    }
  };
  render() {
    const { canSubmit , run, steps, stepIndex } = this.state;
    const { submitting, error, hasParams, selectedRow, isView } = this.props;
    let postId = selectedRow && selectedRow.id;

    const createdStartDate =
      this.createdStartDate && this.createdStartDate.state.date;
    const createdEndDate =
      this.createdEndDate && this.createdEndDate.state.date;
    const isWholeDay =
      this.isWholeDayCheckBox && this.isWholeDayCheckBox.state.value;
    return (
      <div>
       <Joyride
          steps={steps}
          scrollToFirstStep
          showProgress
          showSkipButton
          styles={{
            options: {
              width: 200,
              height: 60,
              zIndex: 1000,
            },
          }}
          callback={this.handleJoyrideCallback}
          run={run}
          stepIndex={stepIndex}
        />
      <Row>
        <Col>
          <Card>
            <CardHeader>{hasParams ? "Edit" : "Create"} Event</CardHeader>
            <CardBody>
              {error && !error.errors ? (
                <UncontrolledAlert color="danger">
                  {error.message}
                </UncontrolledAlert>
              ) : null}
              {error && error.errors && error.errors.length ? (
                <UncontrolledAlert color="danger">
                  {error.errors.map((error, index) => (
                    <p key={index}>{error.message}</p>
                  ))}
                </UncontrolledAlert>
              ) : null}
              <Formsy
                ref="eventForm"
                onValidSubmit={this.handleSubmit}
                onValid={this.enableButton}
                onInvalid={this.disableButton}
                noValidate
              >
                <TextInput
                  name="title"
                  value={selectedRow && hasParams ? selectedRow.title : null}
                  required
                  disabled={submitting || isView}
                  title="Title"
                  validations={{
                    minLength: 3,
                    maxLength: 50
                  }}
                  validationErrors={{
                    minLength: "Minimum of 3 characters allowed",
                    maxLength: "Maximum of 50 characters allowed"
                  }}
                />
                <TextInput
                  name="location"
                  type="textarea"
                  required
                  value={hasParams && selectedRow ? selectedRow.location : null}
                  disabled={submitting || isView}
                  title="Location"
                  validations={{
                    minLength: 3
                  }}
                  validationErrors={{
                    minLength: "Minimum of 5 characters allowed",
                    maxLength: "Maximum of 50 characters allowed"
                  }}
                />
                <TextInput
                  name="description"
                  type="textarea"
                  required
                  value={
                    hasParams && selectedRow ? selectedRow.description : null
                  }
                  disabled={submitting || isView}
                  title="Description"
                  validations={{
                    minLength: 3
                  }}
                  validationErrors={{
                    minLength: "Minimum of 5 characters allowed",
                    maxLength: "Maximum of 50 characters allowed"
                  }}
                />
                {/* <MyCheckbox
                  name="isWholeDay"
                  id="isWholeDay"
                  title="All day event?"
                  innerRef={c => {
                    this.isWholeDayCheckBox = c;
                  }}
                  disabled={submitting}
                /> */}
                <DatePicker
                  name="startDate"
                  required
                  label={"Created Date (From)"}
                  title="Start Date"
                  isTime={isWholeDay ? false : true}
                  disabled={submitting || isView}
                  defaultValue={
                    hasParams && selectedRow && selectedRow.startDate
                  }
                  startDate={createdStartDate}
                  endDate={createdEndDate}
                  minDate={new Date()}
                  maxDate={createdEndDate}
                  isStart={true}
                  isEnd={false}
                  innerRef={c => {
                    this.createdStartDate = c;
                  }}
                />
                <DatePicker
                  name="endDate"
                  required
                  label={"Created Date (From)"}
                  disabled={submitting || isWholeDay || isView}
                  defaultValue={hasParams && selectedRow && selectedRow.endDate}
                  title="End Date"
                  isTime={true}
                  startDate={createdStartDate}
                  endDate={createdEndDate}
                  isStart={false}
                  isEnd={true}
                  minDate={createdStartDate || new Date()}
                  innerRef={c => {
                    this.createdEndDate = c;
                  }}
                />
                <Button
                  type="submit"
                  color="primary"
                  disabled={!canSubmit || submitting || isView}
                  className="pp3"
                >
                  {submitting ? (
                    <Spinner size="sm" />
                  ) : (
                    <span>
                      {hasParams ? "Update" : "Create"} <MdAdd size={20} />
                    </span>
                  )}
                </Button>{" "}
                {hasParams ? (
                  <Button
                    type="button"
                    outline
                    color="primary"
                    onClick={() => this.reset()}
                    className="mr-1"
                  >
                    Reset
                  </Button>
                ) : null}
                {isView && (
                  <Link
                    to={{
                      pathname: ViewEventsAttendees,
                      state: { postId: postId, selectedRow: selectedRow }
                    }}
                  >
                    <Button type="button" color="success">
                      <MdSearch size={20} /> <span>View Attendees</span>
                    </Button>
                  </Link>
                )}
              </Formsy>
            </CardBody>
          </Card>
        </Col>
      </Row>
      </div>
    );
  }
}

export default EventForm;
